const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0
};

export const lazyLoadImage = (image: HTMLImageElement, src: string) => {
    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            image.src = src;
            observer.unobserve(image);
        }
    }, options);
    observer.observe(image);

    return {
        destroy() { }
    };
};